import { useStaticQuery, graphql } from "gatsby";

const useThemeOptions = () => {
  const data = useStaticQuery(
    graphql`
      query {
        sitePlugin(name: { eq: "@flogy/gatsby-theme-fgs-legal" }) {
          pluginOptions {
            currentWebsiteUrl
            companyNominative
            companyDative
            companyAccusative
            companyLocation
            impressum {
              path
              addresses {
                title
                company
                companyDescription
                name
                street
                location
                email
                website
                companyUid
              }
            }
            dataPrivacy {
              path
              usedFeatures
              lastChangedDate
              responsiblePerson {
                nameAccusative
                email
              }
            }
            cookieBanner {
              enable
            }
          }
        }
      }
    `
  );
  return data.sitePlugin.pluginOptions;
};

export default useThemeOptions;
